import { api } from "@/services/api"
import type { CourseTargetObjetive } from "@/services/api/cronos/courses/get"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useUpdateTargetObjective() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      courseId,
      targetObjective,
    }: {
      courseId: string
      targetObjective: CourseTargetObjetive
    }) => api.cronos.courses.updateTargetObjetive(courseId, targetObjective),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["planner-get-weekly-objectives"] })
    },
  })
}
